'use es6';

import { DEAL_REGISTRATION_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from '../ObjectDefinitionRecord';
const DealRegistration = ObjectDefinitionRecord({
  hasAccess: (__isUngated, hasScope) => hasScope('shared-deals-index-page-read'),
  objectTypeId: DEAL_REGISTRATION_ID,
  referenceObjectType: 'DEAL_REGISTRATION_PROPERTIES'
});
export default DealRegistration;